import { createApi } from "@reduxjs/toolkit/query/react";
import { mockApi } from "../Constant";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const MockApi = createApi({
    reducerPath: "MockApi",
    baseQuery: encryptedBaseQueryWithReauth(),
    endpoints: (builder) => ({

        getMockList: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["geetMockList"],
        }),

        createMock: builder.mutation({
            query: ({ data }) => ({
                url: `${mockApi.endPoint}/create`,
                method: "POST",
                body: data,

            }),
            invalidatesTags: [],
        }),
        updateMock: builder.mutation({
            query: ({ data, id }) => ({
                url: `${mockApi.endPoint}/update/${id}`,
                method: "PUT",
                body: data,

            }),
            invalidatesTags: [],
        }),
    }),
});

export const {
    useCreateMockMutation,
    useGetMockListQuery,
    useUpdateMockMutation,
} = MockApi;
